import {
  LOADMONEYTO_PREPAIDCARD_FAILED,
  LOADMONEYTO_PREPAIDCARD_INVALID_REQUEST,
  LOADMONEYTO_PREPAIDCARD_NOTFOUND,
  LOADMONEYTO_PREPAIDCARD_SUCCESS,
  LOADING_LOADMONEYTO_PREPAIDCARD,
  RESET_LOADMONEYTO_PREPAIDCARD
} from "../types";

const initialState = {
  isLoading: false,
  failed: false,
  invalidRequest: false,
  notFound: false,
  success: false,
  networkError: "",
  status: ""
};

export default (state = initialState, action) => {
  switch (action.type) {
    case LOADING_LOADMONEYTO_PREPAIDCARD:
      return {
        ...state,
        isLoading: true,
        failed: false,
        invalidRequest: false,
        notFound: false,
        success: false,
        networkError: "",
        status: {}
      };
    case LOADMONEYTO_PREPAIDCARD_FAILED:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: false,
        failed: true,
        networkError: "",
        status: action.payload.status
      };

    case LOADMONEYTO_PREPAIDCARD_NOTFOUND:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: false,
        notFound: true,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case LOADMONEYTO_PREPAIDCARD_INVALID_REQUEST:
      return {
        ...state,
        isLoading: false,
        success: false,
        invalidRequest: true,
        notFound: false,
        failed: false,
        networkError: "",
        status: action.payload.status
      };
    case LOADMONEYTO_PREPAIDCARD_SUCCESS:
      return {
        ...state,
        isLoading: false,
        failed: false,
        success: true,
        invalidRequest: false,
        notFound: false,
        networkError: "",
        status: action.payload.status
      };

    case RESET_LOADMONEYTO_PREPAIDCARD:
      return (state = initialState);

    default:
      return state;
  }
};
